import React, { Component } from "react";
import { DFPSlotsProvider, AdSlot, DFPManager } from "react-dfp";
import dfpslotsprovider from "react-dfp/lib/dfpslotsprovider";
import { mapping } from '../../utilities'

const BannerRectangle = ({ osCode, agency }) => {

    const dfpData = osCode
        ? osCode
        : "ALL";
    var tag = mapping[dfpData];
    
    if(agency){
        localStorage.setItem('dfpTag','agency'),
        localStorage.setItem('dfpValue','Y')
      }else{
        if(osCode){
          localStorage.setItem('dfpTag','os_code'),
          localStorage.setItem('dfpValue',tag)
        }else{
          localStorage.setItem('dfpTag','os_code'),
          localStorage.setItem('dfpValue','ALL')
        }
      }

    return (
        <div style={{ height: 250, width: 300, margin: "0px auto 24px auto" }}>
        <DFPSlotsProvider
            dfpNetworkId="73516391/homepage-medium-rectangle"
            sizeMapping={[{ viewport: [0, 0], sizes: [300, 250] }]}
        >
            {agency ? 
                <AdSlot
                    style={{ margin: "25px 0" }}
                    dfpNetworkId="73516391/homepage-medium-rectangle"
                    adUnit="div-gpt-ad-1512999135502-1"
                    targetingArguments={{ agency: "Y" }}
                    sizes={[[300, 250]]}
                    shouldRefresh={() => true}
                />
            : (tag ? (
            <AdSlot
                style={{ margin: "25px 0" }}
                dfpNetworkId="73516391/homepage-medium-rectangle"
                adUnit="div-gpt-ad-1512999135502-1"
                targetingArguments={{ os_dest: tag }}
                sizes={[[300, 250]]}
                shouldRefresh={() => true}
            />
            ) : (
            <AdSlot
                style={{ margin: "25px 0" }}
                dfpNetworkId="73516391/homepage-medium-rectangle"
                adUnit="div-gpt-ad-1512999135502-1"
                targetingArguments={{ os_dest: "ALL" }}
                sizes={[[300, 250]]}
                shouldRefresh={() => true}
            />
            ))}
        </DFPSlotsProvider>
        </div>
    );
};

export default BannerRectangle;



// WEBPACK FOOTER //
// ./src/components/Banner/BannerRectangle.js